import { tokenExIframe } from './TokenExIframe'

export default tokenExIframe
export { tokenExIframe }
